import type { Node, RichContent } from './../../ricos-schema/legacy/wix/rich_content/v1';

type NodeContainer = Node | RichContent;

type NodeContext = {
  parents: Node[];
  previousSibling: Node | undefined;
};
export type NodeVisitor<T> = (node: Node, context: NodeContext) => T;
export type NodeFilter = NodeVisitor<boolean>;

const visitNodes =
  (visitorFn: NodeVisitor<void>) =>
  ({ nodes }: NodeContainer): void => {
    type NodeTask = [Node, NodeContext];

    const nodesToTasks = (nodes: Node[], parents: Node[]) =>
      nodes.map<NodeTask>((node, i, nodes) => [node, { parents, previousSibling: nodes[i - 1] }]);

    let tasks: NodeTask[] = nodesToTasks(nodes ?? [], []);
    // eslint-disable-next-line fp/no-loops
    while (tasks.length) {
      const [node, context] = tasks.shift() as NodeTask;
      visitorFn(node, context);
      const parents = [node, ...context.parents];
      // Depth-first. Reverse merge order for breadth-first.
      tasks = [...nodesToTasks(node.nodes || [], parents), ...tasks];
    }
  };

export const getFilteredNodes =
  (filterFn: NodeFilter) =>
  (container: NodeContainer): Node[] => {
    const result: Node[] = [];
    visitNodes((node, context) => {
      if (filterFn(node, context)) {
        result.push(node);
      }
    })(container);
    return result;
  };
